import React from 'react';

const Loader: React.FC = () => {
    return (
        <div className="d-flex justify-content-center py-4">
            <div className="spinner-border" role="status">
                <span className="sr-only"></span>
            </div>
        </div>
    );
};

export default Loader;
